<template>
    <section class="system-config">
      <header>
        <ul>
          <span v-for="(item, index) in tabList" :key="index">
            <li
              @click="tabClick(item.name)"
              :class="item.name == tabName ? 'act' : ''"
              v-if="$IA(item.authKey)"
            >
              <span v-text="item.title"></span>
            </li>
          </span>
        </ul>
        <div>
  
        </div>
      </header>
      <main >
        <component
          :is="tabName"
          @childMessage="handleChildMessage"
        ></component>
      </main>

      <!-- 导入-->
      <a-modal
          centered
          title="提示"
          :visible="promptModalVisible"
          @ok="handleConfirm"
          cancel-text="取消"
          ok-text="确定"
          @cancel="promptModalVisible = false"
          :maskClosable="false"
      >
        <p  class="tips-box">
          <a-icon  type="exclamation-circle" theme="filled" />
          <label>当前页面存在未保存数据，离开将丢失，是否继续?</label>
        </p>
      </a-modal>



    </section>
  </template>
  
  <script>
  export default {
    data() {
      return {
        // tab切换菜单项
        tabList: [
          {
            title: "邮件配置",
            name: "mailConfigure",
            authKey: "system:setting:email",
          },
          // {
          //   title: "录屏配置",
          //   name: "systemConfigure",
          // },
          {
            title: "Logo配置",
            name: "logoConfigure",
            authKey: "system:setting:logo",
          },
          {
            title: "初始化配置",
            name: "initializeConfigure",
            authKey: "system:setting:orginit",
          },
          {
            title: "版本管理",
            name: "versionManagement",
            authKey: "system:setting:version",
          },
          {
            title: "日志清理设置",
            name: "logCleaningSettings",
            authKey: "system:setting:logclean",
          },
          {
            title: "登录安全设置",
            name: "loginSecuritySettings",
            authKey: "system:setting:login",
          },
          {
            title: "数据库备份",
            name: "databaseBackup",
            authKey: "system:setting:login",
          },
        ],
        // 当前tab页名
        tabName: "mailConfigure",

        //点击跳转标签名
        nextTab: "",

        promptModalVisible:false,
        placeholder:'',
        placeholderName:''
      };
    },
    components: {
      mailConfigure: () => import("./systemConfig/M_mailConfigure.vue"),
      systemConfigure: () => import("./systemConfig/M_systemConfigure.vue"),
      logoConfigure: () => import("./systemConfig/M_logoConfigure.vue"),
      initializeConfigure: () => import("./systemConfig/M_initializeConfigure.vue"),
      logCleaningSettings: () => import("./systemConfig/M_logCleaningSettings.vue"),
      loginSecuritySettings: () => import("./systemConfig/M_loginSecuritySettings.vue"),
      versionManagement: () => import("./systemConfig/M_versionManagement.vue"),
      databaseBackup: () => import("./systemConfig/M_databaseBackup.vue"),
    },
    methods: {
      tabClick(name){


        this.placeholderName = name

        if (this.placeholder == '未保存'){
          this.promptModalVisible = true
        }else{
          this.tabName = name
        }

        // 判断是否为登录安全设置，则切换回来清空占位信息
        if (name != 'loginSecuritySettings'){
          this.placeholder = ''
        }
      },

      // 判断离开页面之前是否有保存
      handleChildMessage(val){
        this.placeholder = val
      },
      // 保存提示信息
      handleConfirm(){
        this.tabName = this.placeholderName
        this.promptModalVisible = false
      }
    },
    beforeMount(){

    }
  };
  </script>
  
  <style lang="scss" scoped>
  .system-config {
    position: relative;
    background-color: #fff;
    border-radius: 4px;
    margin: -8px;
    header {
      position: absolute;
      z-index: 9;
      box-sizing: border-box;
      width: 100%;
      padding: 12px 20px 0px;
      //background-color: #fff;
      //border-top: 1px #e4e8ec solid;
      padding-bottom: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title {
        display: flex;
        justify-content: space-between;
        // align-items: center;
      }
      ul {
        display: flex;
        height: 50px;
        line-height: 62px;
        span{
          margin-right: 20px;
        }
        li {
          display: inline-block;
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          width: 100%;
          text-align: center;
          background: #fff;
          border-radius: 20px;
          font-weight: 600;

          border-bottom: 3px solid transparent;
          padding: 0 5px;
          margin-right: 20px;
          //font-weight: 600;
          cursor: pointer;
          white-space: nowrap;
          border: 1px solid #fff;
          span{
            margin-right: 0px;
          }
          i {
            display: inline-block;
            width: 20px;
            height: 20px;
            background-repeat: no-repeat;
            background-position: center;
            vertical-align: text-bottom;
            margin-right: 10px;
          }
          &:hover {
            background-color: #ecf0fe;
            border: 1px solid #3c65f5;
            color: #3c65f5;
            //color: #3c65f5;
          }
          &.act {
            border: 1px solid #3c65f5;
            background: #edeffb;
            color: #3c65f5;
            //color: #3c65f5;
            //border-bottom-color: #3c65f5;
            //margin-bottom: -2px;
          }
        }
      }
    }
    main {
      position: absolute;
      // width: calc(100% - 40px);
      width: calc(100% - 0px);
      // background-color: #fff;
      padding: 60px 20px 20px;
    }
    .clear-float {
      clear: both;
    }
  }
  .tips-box{
    display: flex;
    align-items: center;
    margin-top: 30px;
    i{
      color:#ff7d00;
      font-size: 20px;
      margin-right: 10px
    }
  }
  </style>
  